"use client";

import { container, item, slideIn } from "@/lib/framer";
import { motion } from "motion/react";
import Link from "next/link";
import { Button } from "../ui/button";
import Image from "next/image";

export const About = () => {
  return (
    <section id="about" className="py-8 md:py-10">
      <div className="container mx-auto px-4">
        <motion.div
          className="mb-12 text-center"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.3 }}
          variants={container}
        >
          <motion.h2
            className="text-3xl font-bold tracking-tight sm:text-4xl"
            variants={item}
          >
            About Our School
          </motion.h2>
          <motion.p className="mt-4 text-muted-foreground" variants={item}>
            Established in 2052 BS, serving the community for over 25 years
          </motion.p>
        </motion.div>
        <div className="grid gap-8 md:grid-cols-2 lg:gap-12">
          <motion.div
            className="space-y-4"
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, amount: 0.3 }}
            variants={slideIn}
          >
            <h3 className="text-2xl font-bold">Our Mission</h3>
            <p className="text-muted-foreground">
              At Shree Janakalyan Boarding School, we are dedicated to providing
              a nurturing and stimulating environment where children can develop
              a love for learning. Our mission is to empower students with
              knowledge, skills, and values that will help them become
              responsible global citizens.
            </p>
            <h3 className="text-2xl font-bold">Our Vision</h3>
            <p className="text-muted-foreground">
              To be a leading educational institution in Pokhara that fosters
              academic excellence, cultural awareness, and personal growth in
              every child.
            </p>
            <div className="pt-4">
              <motion.div
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                <Link href="/about">
                  <Button>Read More About Us</Button>
                </Link>
              </motion.div>
            </div>
          </motion.div>
          <motion.div
            className="relative h-[300px] overflow-hidden rounded-lg sm:h-[400px]"
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Image
              src="https://res.cloudinary.com/ds1npuv1v/image/upload/v1742037494/about_eqgo0k.jpg"
              alt="School building and grounds"
              fill
              className="object-cover"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
